import React, { memo } from 'react'
import Select from 'atpjs/components/form/select'

const MAX_BRANCHES_DISPLAYED_IN_TABS = 3

const computeClassName = (value, id) => {
  const classNames = ['atp-time-tabs__entry']
  if (value === id) classNames.push('atp-time-tabs__entry--current')
  return classNames.join(' ')
}

const Branches = memo(({ branchValues, branchId, handleBranchId }) => {
  if (branchValues.length === 0) return null

  if (branchValues.length > MAX_BRANCHES_DISPLAYED_IN_TABS) {
    return (
      <Select
        hasEmpty={false}
        label={false}
        value={branchId}
        values={branchValues}
        wrapperClassName="atp-margin-top-s atp-margin-bottom-xs"
        onChange={handleBranchId}
      />
    )
  }

  return (
    <ul className="atp-time-tabs">
      {branchValues.map(({ value, label }) => {
        return (
          <li key={value} className={computeClassName(value, branchId)} onClick={() => handleBranchId(value)}>
            {label}
          </li>
        )
      })}
    </ul>
  )
})
Branches.displayName = 'Branches'

export default Branches
